// extracted by mini-css-extract-plugin
export default {"Toolbar":"Toolbar_Toolbar__wyFyE","slide-in":"Toolbar_slide-in__kIVSM","DesktopOnly":"Toolbar_DesktopOnly__QdikG"};